import { createRequestTypes } from 'common/websocket-redux';

export const DELETE_DIRECT_DEPOSIT =
  'delete-direct-deposit/DELETE_DIRECT_DEPOSIT';
export const REQUEST_DELETE_DIRECT_DEPOSIT = createRequestTypes(
  'delete-direct-deposit/REQUEST_DELETE_DIRECT_DEPOSIT',
);
